/**
 * @file machine_app_definitions.js
 * @author MachineApps Team
 *
 * @description The MachineAppImplementationManager stores a list of available MachineApps,
 * as well as some information about how we can create an instance of a particular MachineApp.
 * You can think of the MachineApp Definitions as containing class definitions of MachineApps,
 * and the MachineApp Library (in machine_app_library.js) as containing object instances
 * created from these definitions.
 *
 */

const { getMachineAppList } = require("./machine_app_implementation_data");

/**
 * Manages a list of available MachineApps that are loaded from the execution engine.
 */
function MachineAppImplementationManager() {
  this.mMachineAppDefinitionList    = [];
  this.mIsLoaded = false;
}

MachineAppImplementationManager.prototype.isLoaded = function() { return this.mIsLoaded; };

/**
 * Retrieve the list of MachineApp types.
 * @returns {MachineAppImplementation[]} List of available MachineApps.
 */
MachineAppImplementationManager.prototype.listMachineAppDefinitions = function() { return this.mMachineAppDefinitionList; };

/**
 * @param {string} pType
 * @returns {MachineAppImplementation}
 */
MachineAppImplementationManager.prototype.getMachineAppDefinitionByType = function(pType) {
  return this.listMachineAppDefinitions().find(function(pMachineApp) { return pMachineApp.getType() === pType; });
};

/**
 * Load all configurations into the definitions list, eventually from a remote source.
 */
MachineAppImplementationManager.prototype.load = function(pRepository) {
  this.mMachineAppDefinitionList = [];
  getMachineAppList().forEach(pMachineAppJson => this.mMachineAppDefinitionList.push(new MachineAppImplementation(pMachineAppJson)));
  this.mIsLoaded = true;
};

/**
 * Contains all the information that we need to create this type of MachineApp.
 *
 * @param name
 * @param {String} type Unique type of this MachineApp (i.e. Palletizer, PathFollowing, etc.).
 * @param {String} uuid Unique ID of this MachineApp.
 * @param {Boolean} isAvailable Indicates if the machine app is available to be used
 * @param pAdmin
 */
function MachineAppImplementation({name, type, uuid, isAvailable, repositoryName, modulePath}) {
  this.mName                = name;
  this.mType                = type;
  this.mUuid                = uuid;
  this.mIsAvailable         = isAvailable;
  this.mRepositoryName      = repositoryName;
  this.mModulePath          = modulePath;
}

MachineAppImplementation.prototype.getName = function() { return this.mName; };
MachineAppImplementation.prototype.getType = function() { return this.mType; };
MachineAppImplementation.prototype.getUuid = function() { return this.mUuid; };
MachineAppImplementation.prototype.getIsAvailable = function() { return this.mIsAvailable; };
MachineAppImplementation.prototype.getRepositoryName = function() { return this.mRepositoryName; };
MachineAppImplementation.prototype.getModule = function(pRepository) {
  return this.mModulePath.reduce((pModule, pPathName) => pModule[pPathName], pRepository);
};

/* Module export glue */
module.exports = {
  instance                        : new MachineAppImplementationManager()
};
